import React from 'react';
import { TenantType } from '../user/enums';
import { UserType } from './UserType';

const MAP: Record<string, TenantType> = {
    TPO: TenantType.TPO,
    PROVIDER: TenantType.PROVIDER,
    INTERNAL: TenantType.INTERNAL,
    ATTORNEY: TenantType.ATTORNEY,
};

const DEFAULT_TENANT_TYPE = TenantType.TPO;

export const getEnvLocalTenantType = (): TenantType => {
    return MAP[process.env.NEXT_PUBLIC_TENANT_TYPE ?? ''] ?? DEFAULT_TENANT_TYPE;
};

export const UserTypeContext = React.createContext<{
    value: UserType;
    setValue: (newUserType: UserType) => void;
}>({
    value: {
        user: getEnvLocalTenantType(),
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setValue: () => {},
});
